export default "__VITE_ASSET__fb44b50a__"